import './instrument';
import './__mocks__/setup';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { UserProvider } from '@state/userContext';
import { queryClient, persistOptions } from './config/queryClient';
import App from './App';
import '@fontsource-variable/mulish';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

TimeAgo.addDefaultLocale(en);

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <App />
        </UserProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

/**
 * Imperative pattern (not `PersistQueryClientProvider`): the declarative
 * provider races cache restoration against `UserProvider`'s session-cookie
 * initialization, which caused the session to be lost. Rendering only after
 * `restorePromise` settles guarantees the cache is hydrated before any
 * provider mounts.
 */
const [, restorePromise] = persistQueryClient({
  queryClient,
  ...persistOptions,
});

restorePromise
  .catch((error) => {
    console.error('Failed to restore persisted query cache', error);
  })
  .finally(renderApp);
